import { stringify } from 'query-string';
import { fetchUtils } from 'ra-core';

export default (
  apiUrl,
  httpClient = fetchUtils.fetchJson,
  countHeader = 'X-Total-Count',
) => ({
  getList: (resource, params) => {
    const { page, perPage } = params.pagination;
    const { field, order } = params.sort;

    const rangeStart = (page - 1) * perPage;
    const rangeEnd = page * perPage - 1;

    const query = {
      ...fetchUtils.flattenObject(params.filter),
      _sort: field,
      _order: order,
      _start: (page - 1) * perPage,
      _end: page * perPage,
      ts: Math.round(Date.now() / 5000),

      // sort: JSON.stringify([field, order]),
      // range: JSON.stringify([rangeStart, rangeEnd]),
      // filter: JSON.stringify(params.filter),
    };
    const url = `${apiUrl}/${resource}?${stringify(query)}`;
    const options =
      countHeader === 'Content-Range'
        ? {
          // Chrome doesn't return `Content-Range` header if no `Range` is provided in the request.
          headers: new Headers({
            Range: `${resource}=${rangeStart}-${rangeEnd}`,
          }),
        }
        : {};

    return httpClient(url, options).then(({ headers, json }) => {
      if (!headers.has(countHeader)) {
        throw new Error(
          `The ${countHeader} header is missing in the HTTP Response. The simple REST data provider expects responses for lists of resources to contain this header with the total number of results to build the pagination. If you are using CORS, did you declare ${countHeader} in the Access-Control-Expose-Headers header?`,
        );
      }
      return {
        data: json.data,
        total:
          countHeader === 'Content-Range'
            ? parseInt(headers.get('content-range').split('/').pop(), 10) :
            parseInt(headers.get(countHeader.toLowerCase()), 10),
      };
    });
  },

  getOne: (resource, params) => httpClient(`${apiUrl}/${resource}/${params.id}`).then(({ json }) => ({
    data: json.data,
  })),

  getMany: (resource, params) => {
    const query = {
      // filter: JSON.stringify({ id: params.ids }),
      ...fetchUtils.flattenObject(params.filter),
      _ids: params.ids.join(','),
    };
    const url = `${apiUrl}/${resource}?${stringify(query)}`;
    return httpClient(url).then(({ json }) => ({ data: json.data }));
  },

  getManyReference: (resource, params) => {
    const { page, perPage } = params.pagination;
    const { field, order } = params.sort;

    const rangeStart = (page - 1) * perPage;
    const rangeEnd = page * perPage - 1;
    const query = {
      ...fetchUtils.flattenObject(params.filter),
      [params.target]: params.id,
      _sort: field,
      _order: order,
      _start: (page - 1) * perPage,
      _end: page * perPage,
      ts: Math.round(Date.now() / 5000),
      // sort: JSON.stringify([field, order]),
      // range: JSON.stringify([(page - 1) * perPage, page * perPage - 1]),
      // filter: JSON.stringify({
      //   ...params.filter,
      //   [params.target]: params.id,
      // }),
    };
    const url = `${apiUrl}/${resource}?${stringify(query)}`;
    const options =
      countHeader === 'Content-Range'
        ? {
          // Chrome doesn't return `Content-Range` header if no `Range` is provided in the request.
          headers: new Headers({
            Range: `${resource}=${rangeStart}-${rangeEnd}`,
          }),
        }
        : {};

    return httpClient(url, options).then(({ headers, json }) => {
      if (!headers.has(countHeader)) {
        throw new Error(
          `The ${countHeader} header is missing in the HTTP Response. The simple REST data provider expects responses for lists of resources to contain this header with the total number of results to build the pagination. If you are using CORS, did you declare ${countHeader} in the Access-Control-Expose-Headers header?`,
        );
      }
      return {
        data: json.data,
        total:
          countHeader === 'Content-Range'
            ? parseInt(
              headers.get('content-range').split('/').pop(),
              10,
            )
            : parseInt(headers.get(countHeader.toLowerCase()), 10),
      };
    });
  },

  update: (resource, params) => {
    const NULL_PERMITTED = ['translators', 'dubbers', 'backgroundMusic', 'adSenseId'];
    console.log('d', params.data);
    const filteredData = Object.keys(params.data)
      .filter((field) => params.data[field] !== params.previousData[field])
      .filter((field) => params.data[field] !== null || NULL_PERMITTED.includes(field))
      .filter((field) => !['createdAt', 'updatedAt'].includes(field))
      .filter((field) => JSON.stringify(params.data[field]) !== JSON.stringify(params.previousData[field]))
      .reduce((all, field) => ({ ...all, [field]: params.data[field] }), {});
    // const filteredData = { "id": 76, "isAutoGenerated": false, "isDeleted": false, "isTranslationDone": true, "isConfirmed": true, "language": "fa-IR", "blocks": [{ "end": 15300, "text": "خب من قصد دارم درمورد تفاوت های بین وارنیش مات و براق صحبت کنم ", "start": 11300, "comments": {}, "character": null, "discussion": {} }, { "end": 20400, "text": "بسیاری از مراجعه کنندگانم وقتی پرتره میکشیدم درخواست وارنیش مات داشتند.", "start": 15600, "comments": {}, "character": null, "discussion": {} }, { "end": 23400, "text": "زیرا نمیخواستند تمامی نقاشی شان براق باشد", "start": 20400, "comments": {}, "character": null, "discussion": {} }, { "end": 26600, "text": "زیرا شاید تابلو را درست از عرض پنجره آویزان کرده اند", "start": 23700, "comments": {}, "character": null, "discussion": {} }, { "end": 31600, "text": "و به یک پنجره بزرگ درخشان نگاه میکنند و میگویند که وارنیش مات را ترجیح میدهند", "start": 26600, "comments": {}, "character": null, "discussion": {} }, { "end": 36800, "text": "اما همانطور که میبینید وارنیش مات جلوی هرگونه بازتابی را میگیرد ", "start": 31800, "comments": {}, "character": null, "discussion": {} }, { "end": 39500, "text": "و شما از هر زاویه ای آنرا خواهید دید.", "start": 37000, "comments": {}, "character": null, "discussion": {} }, { "end": 47100, "text": "پس در روشنایی کامل مثل کیفیت نورپردازی این موزه، میتوانید دریابید که وارنیش براق تا چه اندازه از وارنیش مات بهتر است", "start": 39500, "comments": {}, "character": null, "discussion": {} }, { "end": 52800, "text": "در واقع تنها موقعیتی که ممکن است وارنیش مات بر وارنیش براق برتری داشته باشد", "start": 47100, "comments": {}, "character": null, "discussion": {} }, { "end": 58500, "text": "جایی است که شما یک تابش خیره کننده ی واضحی درست در سطح نقاشی داشته باشید.", "start": 52800, "comments": {}, "character": null, "discussion": {} }, { "end": 62000, "text": "و شاید تنها موردی است که وارنیش مات عملکرد بهتری دارد", "start": 58700, "comments": {}, "character": null, "discussion": {} }, { "end": 65500, "text": "اما در هر مورد دیگری وارنیش براق را ترجیح میدهم", "start": 62000, "comments": {}, "character": null, "discussion": {} }, { "end": 69900, "text": "خصوصا وقتی میخواهید نقاشی را در نورپردازی موزه قرار دهید", "start": 65900, "comments": {}, "character": null, "discussion": {} }, { "end": 73200, "text": "و یا حتی زمانی که قصد دارید از آن عکس خوبی بگیرید", "start": 70000, "comments": {}, "character": null, "discussion": {} }, { "end": 75300, "text": "میبینید که رنگ ها چقدر قوی تر هستند", "start": 73200, "comments": {}, "character": null, "discussion": {} }, { "end": 81400, "text": "و تا چه اندازه در سیاهی ها، وارنیش مات عمق بهتری نسبت به وارنیش براق میدهد", "start": 76300, "comments": {}, "character": null, "discussion": {} }, { "end": 86200, "text": "البته شرایطی وجود دارد که افراد به جلوه ای که وارنیش مات میدهد علاقه دارند", "start": 81800, "comments": {}, "character": null, "discussion": {} }, { "end": 90800, "text": "اگر کار هنری میکنید و این چیزیست که به رسیدن به آن تلاش میکنید، بحث آن متفاوت است", "start": 86200, "comments": {}, "character": null, "discussion": {} }, { "end": 93000, "text": "استفاده از وارنیش مات اشکالی ندارد", "start": 90800, "comments": {}, "character": null, "discussion": {} }, { "end": 100800, "text": "اما فقط درمورد قرار دادن وارنیش براق در مقابل وارنیش مات بر روی یک نقاشی واقع گرایانه رنگ روغن، ", "start": 93400, "comments": {}, "character": null, "discussion": {} }, { "end": 106000, "text": "شما واقعا بسیاری از جزئیات را در سایه و شدت زیادی از رنگ را از دست می دهید.", "start": 101100, "comments": {}, "character": null, "discussion": {} }, { "end": 111000, "text": "بنابراین من بیشتر وارنیش براق را به وارنیش مات ترجیح میدهم.", "start": 106200, "comments": {}, "character": null, "discussion": {} }], "mediaId": 236, "durationRestriction": null, "createdAt": "2021-08-11T17:00:43.863Z", "updatedAt": "2021-08-12T12:06:51.257Z" };
    return httpClient(`${apiUrl}/${resource}/${params.id}`, {
      method: 'PUT',
      body: JSON.stringify(filteredData),
    }).then(({ json }) => ({ data: json.data }));
  },

  // simple-rest doesn't handle provide an updateMany route, so we fallback to calling update n times instead
  updateMany: (resource, params) => Promise.all(
    params.ids.map((id) => httpClient(`${apiUrl}/${resource}/${id}`, {
      method: 'PUT',
      body: JSON.stringify(params.data),
    })),
  ).then((responses) => ({ data: responses.map(({ json }) => json.data.id) })),

  create: (resource, params) => httpClient(`${apiUrl}/${resource}`, {
    method: 'POST',
    body: JSON.stringify(params.data),
  }).then(({ json }) => ({
    data: { ...params.data, id: json.data.id },
  })),

  delete: (resource, params) => httpClient(`${apiUrl}/${resource}/${params.id}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'text/plain',
    },
  }).then(({ json }) => ({ data: json.data })),

  // simple-rest doesn't handle filters on DELETE route, so we fallback to calling DELETE n times instead
  deleteMany: (resource, params) => Promise.all(
    params.ids.map((id) => httpClient(`${apiUrl}/${resource}/${id}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'text/plain',
      },
    })),
  ).then((responses) => ({
    data: responses.map(({ json }) => (json?.data && json.data.id)),
  })),
});
